export const getVisibleElement = reducer => Object.keys(reducer)
    .map(key => ({
        key,
        ...reducer[key]
    }))
    .find(element => element.isVisible);

export const getDrawerByType = type => state => state.drawer[type];
